import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";

export default function AvaliacoesAdmin() {
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("pendente");

  useEffect(() => {
    fetchAvaliacoes();
  }, [filter]);

  const fetchAvaliacoes = async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: queryError } = await supabase
        .from("avaliacoes")
        .select("*")
        .eq("status", filter)
        .order("created_at", { ascending: false });

      if (queryError) {
        console.error("Erro ao buscar avaliacoes:", queryError);
        setError(queryError.message);
        setAvaliacoes([]);
      } else {
        setAvaliacoes(data || []);
      }
    } catch (err) {
      console.error("Erro inesperado:", err);
      setError("Erro ao carregar dados");
      setAvaliacoes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAprovar = async (id) => {
    await supabase.from("avaliacoes").update({ status: "aprovado" }).eq("id", id);
    await logAction("aprovar_avaliacao", "avaliacao", id);
    fetchAvaliacoes();
  };

  const handleRejeitar = async (id) => {
    const motivo = prompt("Motivo da rejeicao:");
    if (motivo) {
      await supabase.from("avaliacoes").update({ status: "rejeitado", motivo_rejeicao: motivo }).eq("id", id);
      await logAction("rejeitar_avaliacao", "avaliacao", id, motivo);
      fetchAvaliacoes();
    }
  };

  const logAction = async (acao, tipo, item_id, motivo = null) => {
    const { data: { session } } = await supabase.auth.getSession();
    if (session) {
      const { data: admin } = await supabase.from("admins").select("id").eq("user_id", session.user.id).single();
      if (admin) {
        await supabase.from("logs_admin").insert({ admin_id: admin.id, acao, tipo, item_id, motivo });
      }
    }
  };

  const renderStars = (nota) => {
    return "★".repeat(nota || 0) + "☆".repeat(5 - (nota || 0));
  };

  return (
    <div>
      <h1 style={{ fontSize: "1.5rem", fontWeight: "700", marginBottom: "1.5rem" }}>
        Avaliacoes
      </h1>

      <div style={{ marginBottom: "1.5rem", display: "flex", gap: "0.5rem" }}>
        {["pendente", "aprovado", "rejeitado"].map((status) => (
          <button
            key={status}
            onClick={() => setFilter(status)}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: filter === status ? "#3b82f6" : "#e5e7eb",
              color: filter === status ? "#fff" : "#374151",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              textTransform: "capitalize"
            }}
          >
            {status}
          </button>
        ))}
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : error ? (
        <p style={{ color: "#dc2626" }}>Erro: {error}</p>
      ) : avaliacoes.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Nenhuma avaliacao {filter}.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          {avaliacoes.map((avaliacao) => (
            <div key={avaliacao.id} style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              padding: "1.5rem",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <h3 style={{ fontWeight: "600", marginBottom: "0.5rem" }}>
                    Empresa ID: {avaliacao.empresa_id || "N/A"}
                  </h3>
                  <p style={{ fontSize: "0.875rem", color: "#f59e0b", marginBottom: "0.5rem" }}>
                    Geral: {renderStars(avaliacao.nota_geral)}
                  </p>
                  <div style={{ fontSize: "0.75rem", color: "#6b7280", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.25rem" }}>
                    <span>Ambiente: {renderStars(avaliacao.nota_ambiente)}</span>
                    <span>Salario: {renderStars(avaliacao.nota_salario)}</span>
                    <span>Lideranca: {renderStars(avaliacao.nota_lideranca_feminina)}</span>
                    <span>Equilibrio: {renderStars(avaliacao.nota_equilibrio)}</span>
                  </div>
                  {avaliacao.comentario && (
                    <p style={{ marginTop: "0.75rem", fontSize: "0.875rem", fontStyle: "italic", color: "#374151" }}>
                      "{avaliacao.comentario}"
                    </p>
                  )}
                </div>
                {filter === "pendente" && (
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <button
                      onClick={() => handleAprovar(avaliacao.id)}
                      style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: "#059669",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer"
                      }}
                    >
                      Aprovar
                    </button>
                    <button
                      onClick={() => handleRejeitar(avaliacao.id)}
                      style={{
                        padding: "0.5rem 1rem",
                        backgroundColor: "#dc2626",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer"
                      }}
                    >
                      Rejeitar
                    </button>
                  </div>
                )}
              </div>
              {avaliacao.motivo_rejeicao && (
                <p style={{ marginTop: "1rem", fontSize: "0.875rem", color: "#dc2626" }}>
                  Motivo: {avaliacao.motivo_rejeicao}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
